module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_1_1@3x.bce48d09.png";